import { BookmarkX, MoreVertical } from "lucide-react";
import { Button } from "@lyder-talk/ui";
import type { BookmarkedSession } from "@/hooks/use-session-bookmark";
import { SidebarRow } from "@/components/layout/SidebarShell";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useSessionBookmark } from "@/hooks/use-session-bookmark";

interface BookmarkItemWithActionsProps {
  session: BookmarkedSession;
  isMobile: boolean;
  onRemove: () => void;
  onClick: () => void;
}

export const BookmarkItemWithActions = ({
  session,
  isMobile,
  onRemove,
  onClick,
}: BookmarkItemWithActionsProps) => {
  const { toggleBookmark, isToggling } = useSessionBookmark(session.session_id);

  const handleRemoveBookmark = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await toggleBookmark();
      onRemove();
    } catch (error) {
      console.error("Error removing bookmark:", error);
    }
  };

  return (
    <SidebarRow
      onClick={isToggling ? undefined : onClick}
      className={isToggling ? "opacity-50 pointer-events-none" : undefined}
      actions={
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6 hover:bg-primary/15 data-[state=open]:bg-primary/15"
              title="More options"
              disabled={isToggling}
              onClick={(e) => e.stopPropagation()}
            >
              <MoreVertical
                className={`text-muted-foreground hover:text-primary ${isMobile ? "w-4 h-4" : "w-3.5 h-3.5"}`}
              />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            side={isMobile ? "bottom" : "right"}
            className={isMobile ? "min-w-[160px]" : "min-w-[140px]"}
          >
            <DropdownMenuItem
              onClick={handleRemoveBookmark}
              className={`text-destructive focus:text-destructive cursor-pointer ${isMobile ? "min-h-[44px] text-base" : ""}`}
              disabled={isToggling}
            >
              <BookmarkX className={`mr-2 ${isMobile ? "w-4 h-4" : "w-3.5 h-3.5"}`} />
              Remove Bookmark
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      }
    >
      <span className="block truncate text-sm">{session.topic}</span>
    </SidebarRow>
  );
};
